import { FC, HTMLProps } from 'react';
import './Box.scss';

interface IBoxProps extends HTMLProps<HTMLDivElement> {
  className?: string;
  bordered?: boolean;
}

const Box: FC<IBoxProps> = ({ children, className = '', bordered = false, ...props }) => {
  return (
    <div className={`Box ${className} ${bordered ? 'bordered' : ''}`} {...props}>
      {children}
    </div>
  );
};

export default Box;
